module.exports = __webpack_public_path__ + "static/img/21.455bab32.png";